import NamedDto from 'modules/base/dto/NamedDto';
import InfrastructureElementLocationEditDto from './InfrastructureElementLocationEditDto';

export class InfrastructureElementEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.elementType = null;
		/** @type {string} */
		this.coordLat = null;
		/** @type {string} */
		this.coordLng = null;
		/** @type {InfrastructureElementLocationEditDto[]} */
		this.locationList = null;
		/** @type {number} */
		this.project = null;
	}

	/**
	 * @typedef {Object} _InfrastructureElementEditDtoProps
	 * @property {string} elementType
	 * @property {string} coordLat
	 * @property {string} coordLng
	 * @property {InfrastructureElementLocationEditDto[]} locationList
	 * @property {number} project
	 * @typedef {import("../NamedDto").NamedDtoProps & _InfrastructureElementEditDtoProps} InfrastructureElementEditDtoProps
	 */
	/**
	 *
	 * @param {InfrastructureElementEditDtoProps} props
	 * @returns {InfrastructureElementEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.elementType = props.elementType;
		this.coordLat = props.coordLat;
		this.coordLng = props.coordLng;
		this.locationList = props.locationList !== null ? props.locationList.map(d => new InfrastructureElementLocationEditDto().setup(d)) : [];
		this.project = props.project;
		return this;
	}
}

export default InfrastructureElementEditDto;
